module.exports = __webpack_public_path__ + "static/media/wordpress.90c46a26.png";